import { computed, ref } from 'vue';
import type { ComputedRef, Ref } from 'vue';

import { useI18n } from 'vue-i18n';

import type { SelectOption } from '@/components/common/types/selectOptionTypes';


const VALUES = ['all', 'near', 'vrs'] as const;

export type BsFilterValue = typeof VALUES[number];

type UseMapBsFilterResult = {
	options: ComputedRef<SelectOption<BsFilterValue>[]>;
	selected: Ref<BsFilterValue>;
};

export function useMapBsFilter(): UseMapBsFilterResult {
	const { t } = useI18n();
	const options = computed((): SelectOption<BsFilterValue>[] => VALUES.map(value => ({
		value,
		label: t('home-map.bsServiceFilter.options.' + value),
	})));
	const selected = ref<BsFilterValue>('all');
	return {
		options,
		selected,
	};
}
